import { number, string, table } from "@rocicorp/zero";

export const vehicleAssignmentsPlan = table("vehicleAssignmentsPlan")
	.from("vehicle_assignments_plan")
	.columns({
		id: string(),
		planId: string().from("plan_id"),
		vehicleId: string().from("vehicle_id"),
		createdBy: string().from("created_by"),
		createdAt: number().from("created_at"),
		userId: string().from("user_id").optional(),
		// The plan's organisation, named by the mutators rather than left to the default.
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
